import React from 'react';

import {V2RequestsFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {getFeatureStatus} from 'auth/feature-enablement/FeatureStatus';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Section as NavSection} from 'constants/NavConstants';
import {
  ColumnAccessorKey,
  ColumnConfiguration,
  ListingRendererType,
  ListingTypes,
} from 'nav/expanded/ListingRendererConstants';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import CollectibleListingRenderer from 'notebook/entry-templates/collections/sidepanel/CollectibleListingRenderer';
import notifications from 'notifications';
import CreateRequestV2SubmissionModal from 'processes/requests_v2/modals/CreateRequestV2SubmissionModal';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import legacyRunModal from 'ui-library/legacyRunModal';
import {TABLE_ROW_BODY_HEIGHT} from 'ui-library/scrollable/ScrollableTableConstants';
import {BasicEvent} from 'util/Types';

export default class RequestV2DefinitionListingRenderer extends CollectibleListingRenderer {
  override listingRendererType = ListingRendererType.REQUEST_V2_DEFINITION;

  override getModelSpecificColumnConfigurations(): Array<
    ColumnConfiguration<ListingTypes[ListingRendererType.REQUEST_V2_DEFINITION]>
  > {
    return [
      {
        column: {
          accessorKey: ColumnAccessorKey.DESCRIPTION,
          header: 'Description',
          isSortable: false,
          flexGrow: 1,
        },
        render: (item) => item.description,
      },
    ];
  }

  override getNonPluginRowContentHeight(): number {
    return TABLE_ROW_BODY_HEIGHT;
  }

  override openContextMenu(
    item: ListingTypes[ListingRendererType.COLLECTIBLE],
    e: BasicEvent,
    options: unknown
  ): void {}

  override renderIcon(item: ListingTypes[ListingRendererType.COLLECTIBLE]): JSX.Element {
    return (
      <BenchlingIcon icon={ModelTypeConstants.REQUEST_V2_DEFINITION} className="scrollableTable-cell-icon" />
    );
  }

  onClick(
    item: ListingTypes[ListingRendererType.REQUEST_V2_DEFINITION],
    openItem: (item: ListingTypes[ListingRendererType.REQUEST_V2_DEFINITION]) => void
  ): void {
    if (SidepanelStore.getSection() === NavSection.REQUESTS_V2_DEFINITIONS) {
      const featureStatus = getFeatureStatus({feature: V2RequestsFeature.V2_REQUESTS_CREATE});
      if (featureStatus.enabled) {
        legacyRunModal(CreateRequestV2SubmissionModal, {
          initialRequestV2DefinitionId: item.id,
          actionOrigin: ActionOrigin.SEARCH_SIDEPANEL,
        });
      } else if (featureStatus.userMessage != null) {
        notifications.warn(featureStatus.userMessage);
      }
    } else {
      openItem(item);
    }
  }
}
